// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"KFspohr0TeHm6fo0a4Wq","shown":"GyKWraRb2I1fqLqHjP5_","sidebar":"TMf0AURPgSqvc0LvcXbh","scrollLock":"E5kWdeltn86uFvPEGkpJ"};